// Per-night price of ONE room for the given occupancy, before tax.
// Shared by the room cards and the cart (ViewCart) so both always agree.
//  - up to default_adult adults: occupancy rate from adult_rates
//    (index 0 is the base row, so it is skipped) or default_adult_rate
//  - above default_adult: default_adult_rate + extra_adult_rate per extra adult
//  - children / infants above the room defaults add their extra rates
export const getRoomNightRate = (roomTypeRow, guests = {}) => {
  const roomType = roomTypeRow?.room_type || {};
  const ratePlan = roomTypeRow?.rate_plan || {};
  const adults = Number(guests.adults) || 0;
  const children = Number(guests.children) || 0;
  const infants = Number(guests.infants) || 0;

  let rate = 0;
  if (roomType.default_adult >= adults) {
    let defaultAdultRate = ratePlan.default_adult_rate;
    const occupancyRate = ratePlan.adult_rates?.find(
      (g, i) => i > 0 && g.numberOfAdult == adults,
    );
    if (occupancyRate) defaultAdultRate = occupancyRate.rate;
    rate += Number(defaultAdultRate) || 0;
  } else {
    const extraAdults = adults - roomType.default_adult;
    rate +=
      (Number(ratePlan.default_adult_rate) || 0) +
      extraAdults * (Number(ratePlan.extra_adult_rate) || 0);
  }

  if (children > roomType.default_children) {
    rate +=
      (children - roomType.default_children) *
      (Number(ratePlan.extra_child_rate) || 0);
  }
  if (infants > roomType.default_infant) {
    rate +=
      (infants - roomType.default_infant) *
      (Number(ratePlan.extra_infant_rate) || 0);
  }
  return rate;
};

// Price shown to the guest: adds tax only when it is not already included.
export const withDisplayTax = (rate, taxGroup) => {
  let total = Number(rate) || 0;
  if (taxGroup?.taxes_inclusive_in_product_price == false) {
    const totalTaxPercent = (taxGroup?.taxes || []).reduce(
      (sum, tax) => sum + Number(tax?.tax_percentage || 0),
      0,
    );
    total += (total * totalTaxPercent) / 100;
  }
  return Math.round(total * 100) / 100;
};
